import { Controller } from "@hotwired/stimulus"

// Confort de saisie du code OTP du Portail Contact :
//   - filtre les caracteres non numeriques ;
//   - soumet automatiquement le formulaire des que 6 chiffres sont saisis
//     (utile pour l'auto-remplissage "one-time-code" iOS / Android).
export default class extends Controller {
  static targets = ["field", "form"]

  connect() {
    if (this.hasFieldTarget) this.fieldTarget.addEventListener("input", this.onInput)
  }

  disconnect() {
    if (this.hasFieldTarget) this.fieldTarget.removeEventListener("input", this.onInput)
  }

  onInput = (event) => {
    const el = event.target
    el.value = el.value.replace(/\D/g, "").slice(0, 6)
    if (el.value.length === 6 && this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
  }
}
